export * from "./cascadedShadowGenerator.pure";

import { RegisterCascadedShadowGenerator } from "./cascadedShadowGenerator.pure";
RegisterCascadedShadowGenerator();
